import { render, staticRenderFns } from "./ArticleHandler.vue?vue&type=template&id=cfae97fa&scoped=true"
import script from "./ArticleHandler.vue?vue&type=script&lang=ts"
export * from "./ArticleHandler.vue?vue&type=script&lang=ts"
import style0 from "./ArticleHandler.vue?vue&type=style&index=0&id=cfae97fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfae97fa",
  null
  
)

export default component.exports